// 5:00 AM through 10:45 PM in 15-minute steps (legacy hour pickers were 5:00–9:00 PM; extended for flexibility)
const OPTIONS = [];
for (let m = 5 * 60; m <= 22 * 60 + 45; m += 15) {
  const h = Math.floor(m / 60);
  const min = m % 60;
  OPTIONS.push(`${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}`);
}

export const RESERVATION_TIME_OPTIONS = OPTIONS;

/** Default boat-reservation window shown when opening the reserve form. */
export const DEFAULT_RESERVATION_START_TIME = '06:30';
export const DEFAULT_RESERVATION_END_TIME = '08:00';


/**
 * YYYY-MM-DD in the club's local time, for <input type="date"> values/min/max.
 * Never use toISOString() here: after ~8pm US Eastern it returns tomorrow in UTC,
 * which would block same-day reservations made in the evening.
 */
export function getLocalISODate(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatReservationTimeLabel(hhmm) {
  if (!hhmm) return '';
  const [hours, minutes] = hhmm.split(':');
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
}

export function reservationTimeToMinutes(hhmm) {
  if (!hhmm) return null;
  const match = String(hhmm).trim().match(/^([01]?\d|2[0-3]):([0-5]\d)(?::[0-5]\d)?$/);
  if (!match) return null;
  return (parseInt(match[1], 10) * 60) + parseInt(match[2], 10);
}

/** YYYY-MM-DD (date input value) to the MM/DD/YYYY form the API stores. */
export function isoDateToReservationDate(isoDate) {
  const match = String(isoDate || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return match ? `${match[2]}/${match[3]}/${match[1]}` : '';
}

/** Non-cancelled holds on one MM/DD/YYYY date, earliest first. */
export function reservationsOnDate(reservations, reservationDate) {
  return (reservations || [])
    .filter((r) => r.reservation_date === reservationDate && r.status !== 'cancelled')
    .sort((a, b) => (reservationTimeToMinutes(a.start_time) ?? 0) - (reservationTimeToMinutes(b.start_time) ?? 0));
}

export function findOverlappingReservations(reservations, reservationDate, startTime, endTime) {
  return reservationsOnDate(reservations, reservationDate).filter((r) =>
    reservationWindowsOverlap(startTime, endTime, r.start_time, r.end_time)
  );
}

export function reservationWindowsOverlap(startA, endA, startB, endB) {
  const aStart = reservationTimeToMinutes(startA);
  const aEnd = reservationTimeToMinutes(endA);
  const bStart = reservationTimeToMinutes(startB);
  const bEnd = reservationTimeToMinutes(endB);
  if ([aStart, aEnd, bStart, bEnd].some((n) => n == null)) return false;
  return aStart < bEnd && aEnd > bStart;
}

/** Club boats: anyone. Private: owners only. */
export function canUserReserveBoat(boat, userId) {
  if (!boat || userId == null) return false;
  if (boat.ownership_type === 'club') return true;
  if (boat.owners && boat.owners.length > 0) {
    return boat.owners.some((o) => o.user_id === userId);
  }
  return boat.owner_id === userId;
}
